import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { Box, Grid2, Typography } from '@mui/material';
import { Container } from 'modules/Checkin/styles';
import { useTranslation } from 'react-i18next';

const CheckinData = ({ booking = {}, isCompleted = false }) => {
    const { t } = useTranslation();
    const translate = (key, options) => t(`checkin.checkin_data.${key}`, options);
    const dateValues = useMemo(() => {
        if (!booking?.dateUTC) return {};

        const date = DateTime.fromISO(booking.dateUTC).setZone(booking?.timezone);
        const dateString = date.toFormat('dd LLL yyyy');
        const arrivalTime = date.toFormat('HH:mm');

        return { dateString, arrivalTime };
    }, [booking]);

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                mx: 'auto',
                px: 3,
                boxSizing: 'border-box',
            }}>
            <Container>
                <Typography variant="h4" component="h1" fontSize={20} fontWeight={900} sx={{ color: '#131313' }}>
                    {t('checkin.title')}
                </Typography>
                {isCompleted && (
                    <Typography variant="h6" fontWeight={800} sx={{ color: '#50C878' }}>
                        {translate('completed')}
                    </Typography>
                )}
            </Container>

            {/* Booking */}
            <Grid2
                container
                size={12}
                justifyContent={{ xs: 'flex-start', md: 'space-evenly' }}
                sx={{
                    p: 4,
                    mb: 2,
                    backgroundColor: '#f5f3f3',
                }}>
                {/* Booking Code */}
                <Container size={6}>
                    <Typography variant="h5" fontSize={24} fontWeight={800}>
                        {translate('booking_code')}
                    </Typography>
                    <Typography>{booking?.code}</Typography>
                </Container>

                {/* Billing Details */}
                <Container size={6}>
                    <Typography variant="h5" fontSize={24} fontWeight={800}>
                        {translate('billing_details')}
                    </Typography>
                    <Box>
                        <Typography>{translate('full_name', { fullName: `${booking?.firstName} ${booking?.lastName}` })}</Typography>
                        <Typography>{translate('email', { email: booking?.email })}</Typography>
                        <Typography>{translate('mobile_phone', { mobilePhone: booking?.mobilePhone })}</Typography>
                    </Box>
                </Container>
            </Grid2>

            {/* Activities */}
            <Typography variant="h5" fontSize={20} fontWeight={900} sx={{ color: '#131313', textTransform: 'none' }}>
                {translate('activities')}
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Grid2 container size={12} justifyContent="center" alignItems="center">
                    <Grid2 container size={6} justifyContent="center">
                        <Typography fontSize={18}>{booking?.name}</Typography>
                    </Grid2>
                    <Grid2 container size={6} direction="column">
                        <Typography>{translate('date', { date: dateValues?.dateString })}</Typography>
                        <Typography>{translate('arrival_time', { arrivalTime: dateValues?.arrivalTime })}</Typography>
                        <Typography>{translate('location', { location: booking?.location })}</Typography>
                        <Typography>{translate('quantity', { quantity: booking?.quantity })}</Typography>
                    </Grid2>
                </Grid2>
            </Box>
        </Box>
    );
};

export default CheckinData;
